import OrderCancelOrderRequest from "../../../../api/raily/order/cancel/order/order-cancel-order.request";
import OrderCancelOrderParams from "./order-cancel-order-params";

const create = (params: OrderCancelOrderParams): OrderCancelOrderRequest => {
  return {
    orderId: params.orderUuid,
  };
};

const orderCancelOrderParamsFactory = {
  create,
};

export default orderCancelOrderParamsFactory;
